module.exports = __webpack_public_path__ + "media/audiosprite.c4d3aa18.mp3";